import styled from 'styled-components';

export const CaptchaWrapper = styled.div<{
  isMobile: boolean;
  isMask: boolean;
  isRTL: boolean;
  isVoice: boolean;
}>`
  font-size: unset;
  div,
  a,
  span,
  svg,
  img {
    font-size: unset;
  }
  background: ${({ theme }) => theme.bgColor};
  box-sizing: border-box;
  overflow: hidden;
  ${({ isRTL }) => isRTL && 'direction: rtl;'}
  ${({ isMobile, isVoice }) => {
    let style_str = `
        width: 3.80em;
        .captcha_verify_img--wrapper {
          width: 3.40em;
          height: 2.12em;
        }
        .captcha_verify_img--wrapper {
          margin: 0 0.20em 0;
        }
        .captcha_verify_bar {
          padding: 0.28em 0.20em 0.16em;
        }
        .verify-bar-close {
          width: 0.16em;
          height: 0.16em;
          padding: 0.16em;
        }
        .captcha_verify_slide--button {
          height: 0.44em;
          margin: 0.04em 0.20em 0;
        }
        .secsdk-captcha-slidebar, 
        .captcha_verify_slide--slidebar,
        .secsdk-captcha-drag-sliding {
          height: 0.44em;
        }
        .secsdk-captcha-drag-icon {
          height: 0.40em;
        }
        .captcha_verify_action {
          padding: 0.16em 0.20em 0.20em;
        }
      `;
    if (isMobile) {
      style_str = `
            width: 3em;
            min-height: 3.04em;
            overflow: hidden;
        `;
    }
    if (isVoice) {
      if (isMobile) {
        style_str = `
            width: 3em;
            overflow: hidden;
        `;
      } else {
        style_str = `
            width: 380px;
            overflow: hidden;
        `;
      }
    }
    return style_str;
  }}
  ${({ isMask, theme }) =>
    isMask
      ? `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: ${theme.borderRadius};
  `
      : `
    margin: 0 auto;
  `}
`;
